// extracted by mini-css-extract-plugin
export default {"links":"link-list-links--f24fb","links__prenav":"link-list-links__prenav--0af66","skip":"link-list-skip--9d091"};